import moment from "moment";

export default {
  name: "HistoryChanged",
  props: {
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },

    historyList: {
      type: Array,
      default: function () {
        return [{}];
      },
    },
    displayFields: {
      type: Array | Object,
      default: [],
    },
  },
  components: {},
  data() {
    return {
      historySelected: 0,
    };
  },
  computed: {},
  created() { },
  methods: {
    handleClickHistory(index, item) {
      this.$emit("mappingDisplayData", item);
      this.historySelected = index;
    },
    displayCreateTime(time) {
      if (!time) {
        return ""
      }

      return moment(time, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY HH:mm')
    }
  },
  mounted() { },
  destroyed() { },
};
